export enum MessageType {
	default = "DEFAULT",
	blue = "BLUE",
	orange = "ORANGE",
	coral = "CORAL",
	red = "RED"
}
